import { Code, Loading, Empty, Card, ColumnLayout } from '@lithos';
import { useParams } from 'react-router';
import { useGetJobLogs } from '../../../api/jobs';

const JobLogs = () => {
  const { jobId } = useParams();
  const { data: jobLogsData, isLoading } = useGetJobLogs(jobId ?? '', { enabled: true });

  if (isLoading) {
    return <Loading />;
  }

  return (
    <>
      {!jobLogsData?.logs?.length ? (
        <div>
          <Empty
            placement="embedded"
            useCase="empty"
            actions={undefined}
            title={<>No Job Logs Available</>}
            description={<>Please try again later.</>}
          />
        </div>
      ) : (
        <>
          <Card>
            <Code code={jobLogsData?.logs ?? ''} />
          </Card>
        </>
      )}
    </>
  );
};

export default JobLogs;
